var PromoUtil = /** @class */ (function () {
    function PromoUtil() {
    }
    PromoUtil.getPermanentOrLessThanAMonthDiscount = function (option) {
        return option.promos.filter(function (promo) { return PromoUtil.isPermanentOrLessThanAMonthPromo(promo); })
            .map(function (promo) { return promo.price; })
            .reduce(function (curr, prev) { return curr + prev; }, 0);
    };
    PromoUtil.getMonthlyDiscount = function (option) {
        return option.promos.filter(function (promo) { return PromoUtil.isMonthlyPromo(promo); })
            .map(function (promo) { return promo.price; })
            .reduce(function (curr, prev) { return curr + prev; }, 0);
    };
    PromoUtil.getMonthlyDiscountForSoho = function (option) {
        return option.promos.filter(function (promo) { return PromoUtil.isMonthlyPromo(promo); })
            .map(function (promo) { return promo.priceexclvat; })
            .reduce(function (curr, prev) { return curr + prev; }, 0);
    };
    PromoUtil.getPromoLabel = function (option) {
        if (option.promos.some(function (promo) { return PromoUtil.isMonthlyPromo(promo); })) {
            return PromoUtil._monthlyLabel;
        }
        if (option.promos.some(function (promo) { return PromoUtil.isPermanentOrLessThanAMonthPromo(promo); })) {
            return PromoUtil._permanentLabel;
        }
        return undefined;
    };
    PromoUtil.isPermanentOrLessThanAMonthPromo = function (promo) {
        return promo.duration === 0 && promo.price < 0;
    };
    PromoUtil.isMonthlyPromo = function (promo) {
        return promo.duration > 0 && promo.price < 0;
    };
    PromoUtil.getShortestPromoDuration = function (option) {
        var duration = option.promos.filter(function (promo) { return PromoUtil.isMonthlyPromo(promo); })
            .map(function (promo) { return promo.duration; })
            .reduce(function (a, b) { return Math.min(a, b); }, PromoUtil._maximumDuration);
        return duration === PromoUtil._maximumDuration ? 0 : duration;
    };
    PromoUtil._maximumDuration = 999;
    PromoUtil._monthlyLabel = 'promo-duration';
    PromoUtil._permanentLabel = 'promo-permanent';
    return PromoUtil;
}());
export { PromoUtil };
